<template>
  <div :class="{ '-icons': isIcon }">
    <transition name="fade">
      <div class="product-detail-container">
        <template v-if="!showCountDownOnProductHeader">
          <Konami
            :konami="konami"
            :countdown="countdown"
            :is-in-product-page="true"
            v-if="code && countdown && countdown > 0"
            key="konami"
          ></Konami>
          <CountdownContainer
            :konami="konami"
            :countdown="countdown"
            :is-in-product-page="true"
            v-else-if="countdown && countdown > 0"
            key="konami"
          ></CountdownContainer>
        </template>
        <div key="content">
          <CmpRenderer
            :components="visibleComponents"
            is-strict-rendering-order
            @mounted-completely="onComponentsMountedCompletely"
          />
          <!-- <StaggeredVisuals :item="{title: 'Omne itaque turbent, lorem caritatem quae.', text: 'Aenean at massa quis erat blandit malesuada vel vel lacus. Donec sollicitudin scelerisque porta. Aenean quis dui nisi. Quisque a odio eget metus hendrerit ornare. Maecenas et justo non enim consectetur vehicula. Fusce facilisis dolor nec neque tempor imperdiet.'}"></StaggeredVisuals> -->
          <!-- <Movement :item="{title: 'Tri-color, tri-compax', text:'<p>An iconic design trait among chronograph wristwatches, the Zenith tri-color chronograph registers have been a signature feature of the brand, ever since the earliest El Primero-equipped watches from 1969.</p>',image:{url:'https://images-staging.zenith-watches.com/website-zenith-pre-prod/b6effc10-1ff3-441a-955b-24913ce5806c_MACRO_A386_01.jpg',alt:'The Zenith tri-color chronograph',width:3000,height:2252,filter:''},ctaText:'découvrir notre savoir-faire',ctaLink:'#'}"></Movement> -->
          <Reassurance v-if="isReassuranceAllowed"></Reassurance>
          <script v-html="stringified" type="application/ld+json"></script>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { currentStoreView } from '@vue-storefront/core/lib/multistore'
import { ProductDetailsComponent } from 'src/modules/prismic/components/ProductDetails'
import Konami from '../components/utils/Konami'
import Movement from '../components/Movement'
import Reassurance from '../components/Reassurance'
import StaggeredVisuals from '../components/StaggeredVisuals'
import config from 'config'
import { isServer } from '@vue-storefront/core/helpers'
import CountdownContainer from '../components/utils/CountdownContainer.vue'

export default {
  name: 'ProductDetails',
  mixins: [ProductDetailsComponent],
  components: {
    Konami,
    CountdownContainer,
    Movement,
    Reassurance,
    StaggeredVisuals
  },
  data() {
    return {
      isReassuranceAllowed: false,
      konamiDisallowedComponents: [
        'product_header',
        'sticky_product_bar',
        'technical_specification_hero',
        'technical_specification'
      ],
      konamiAvailable: false,
      countdownLoadedClient: false,
      countdown: null,
      showCountDownOnProductHeader: false
    }
  },
  asyncData({ context }) {
    return new Promise((resolve, reject) => {
      if (context) context.output.cacheTags.add(`product`)
      return resolve()
    })
  },
  mounted() {
    //Forwarded event because changing "overlay" global variable ("konami" group)
    //doesn't trigger visibleComponents recalculation
    this.$bus.$on('setCountdown',(countdownValue) => {this.countdown = countdownValue})
    this.showCountDownOnProductHeader = this.page && this.page.main && !!this.page.main.use_konami_on_product_header
    const isProductUnaivailable = this.components.filter(
      ({ component }) => component === 'product_header_error'
    ).length
    if (isProductUnaivailable) {
      let { url } = currentStoreView()
      url = url || ''
      this.$router.push({ path: url + '/page-not-found' })
    }
  },
  computed: {
    stringified() {
      return JSON.stringify(this.productJsonLd)
    },
    clientUrl() {
      return config.client.url
    },
    isIcon() {
      return (
        this.page &&
        this.page.main &&
        this.page.main.product &&
        this.page.main.product.product[currentStoreView().storeCode] &&
        this.page.main.product.product[currentStoreView().storeCode].is_icon
      )
    },
    visibleComponents() {
      let isBlocked = false

      let countdown = null
      let konamiAvailable = false
      let countdownLoadedClient = false

      if (!isServer) {
        if (!this.konami) {
          countdownLoadedClient = true
        } else if (!this.countdown) {
          const availableUntil = new Date(this.konami.available_date)
          const now = new Date()

          countdown = availableUntil.getTime() - now.getTime()
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.countdown = countdown

          countdownLoadedClient = true
          konamiAvailable = countdown > 0
        }
      }

      if (countdownLoadedClient) {
        isBlocked = konamiAvailable
      } else if (this.code && !countdownLoadedClient) {
        isBlocked = true
      }

      if (isBlocked && !this.showCountDownOnProductHeader) {
        return this.modifiedComponents.filter(
          cmp => !this.konamiDisallowedComponents.includes(cmp.component)
        )
      }

      this.setCode({ code: null })
      return this.modifiedComponents
    }
  },
  methods: {
    // NOTE: We have to ensure that everything inside CmpRender is mounted before Reassurance
    onComponentsMountedCompletely() {
      this.isReassuranceAllowed = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';

// Fade
.fade-enter,
.fade-leave-to {
  left: 0;
  right: 0;
}

.product-detail-container {
  /deep/ {
    .konami {
      position: relative;
      padding: 0;
      height: $hero-available-height;

      .container {
        position: absolute;
        top: 20%;
        left: 50%;
        transform: translateX(-50%);
      }

      .visual {
        margin: 0;
        max-height: 100%;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }

      .title {
        margin-bottom: 32px;
      }

      .text {
        margin-bottom: 32px;

        @include bp(md) {
          font-size: em(20);
        }
      }

      input {
        border: 1px solid white;
        border-radius: 12px;
        padding: 1rem 2rem;
      }

      .form-line:not(.-top) > label:not(.btn) {
        top: 1.7rem;
      }
    }
  }
}
</style>
